import { Button, PageHeader } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { ArchiveGroups } from './archive-groups.component'
import { ArchivePosts } from './archive-posts.component'
import s from './archive.module.less'

enum ArchiveMode {
  ArchivedPost = 'archivedPost',
  ArchivedGroup = 'archivedGroup',
}

export const ArchiveContainer = () => {
  const { t } = useTranslation()
  const [tab, setTab] = React.useState<ArchiveMode>(ArchiveMode.ArchivedPost)

  const content = tab === ArchiveMode.ArchivedPost ? <ArchivePosts /> : <ArchiveGroups />

  return (
    <PageHeader
      title={t(`personalMenu.${tab}`)}
      extra={[
        <Button
          key={ArchiveMode.ArchivedPost}
          type='primary'
          ghost={tab !== ArchiveMode.ArchivedPost}
          onClick={() => setTab(ArchiveMode.ArchivedPost)}
        >
          {t('personalMenu.archivedPost')}
        </Button>,
        <Button
          key={ArchiveMode.ArchivedGroup}
          type='primary'
          ghost={tab !== ArchiveMode.ArchivedGroup}
          onClick={() => setTab(ArchiveMode.ArchivedGroup)}
        >
          {t('personalMenu.archivedGroup')}
        </Button>,
      ]}
    >
      <div className={s.container}>{content}</div>
    </PageHeader>
  )
}
